export const stripe_countries = {
	en: {
		France: 'France',
		Austria: 'Austria',
		Belgium: 'Belgium',
		Bulgaria: 'Bulgaria',
		Croatia: 'Croatia',
		Cyprus: 'Cyprus',
		'Czech Republic': 'Czech Republic',
		Denmark: 'Denmark',
		Estonia: 'Estonia',
		Finland: 'Finland',
		Germany: 'Germany',
		Gibraltar: 'Gibraltar',
		Greece: 'Greece',
		Hungary: 'Hungary',
		Ireland: 'Ireland',
		Italy: 'Italy',
		Latvia: 'Latvia',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Lithuania',
		Luxembourg: 'Luxembourg',
		Malta: 'Malta',
		Netherlands: 'Netherlands',
		Norway: 'Norway',
		Poland: 'Poland',
		Portugal: 'Portugal',
		Romania: 'Romania',
		Slovakia: 'Slovakia',
		Spain: 'Spain',
		Sweden: 'Sweden',
		Switzerland: 'Switzerland',
		'United Kingdom': 'United Kingdom',
		'Dominican Republic': 'Dominican Republic',
		Albania: 'Albania',
		Algeria: 'Algeria',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua & Barbuda',
		Argentina: 'Argentina',
		Armenia: 'Armenia',
		Australia: 'Australia',
		Azerbaijan: 'Azerbaijan',
		Bahamas: 'Bahamas',
		Bahrain: 'Bahrain',
		Bangladesh: 'Bangladesh',
		Benin: 'Benin',
		Bhutan: 'Bhutan',
		Bolivia: 'Bolivia',
		'Bosnia & Herzegovina': 'Bosnia & Herzegovina',
		Botswana: 'Botswana',
		Brunei: 'Brunei',
		Cambodia: 'Cambodia',
		Canada: 'Canada',
		Chile: 'Chile',
		Colombia: 'Colombia',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': 'Côte d’Ivoire',
		Ecuador: 'Ecuador',
		Egypt: 'Egypt',
		'El Salvador': 'El Salvador',
		Ethiopia: 'Ethiopia',
		Gabon: 'Gabon',
		Gambia: 'Gambia',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hong Kong',
		Indonesia: 'Indonesia',
		Israel: 'Israel',
		Jamaica: 'Jamaica',
		Japan: 'Japan',
		Jordan: 'Jordan',
		Kazakhstan: 'Kazakhstan',
		Kenya: 'Kenya',
		Kuwait: 'Kuwait',
		Laos: 'Laos',
		'Macao SAR China': 'Macao SAR China',
		Madagascar: 'Madagascar',
		Malaysia: 'Malaysia',
		Mauritius: 'Mauritius',
		Mexico: 'Mexico',
		Moldova: 'Moldova',
		Monaco: 'Monaco',
		Mongolia: 'Mongolia',
		Morocco: 'Morocco',
		Mozambique: 'Mozambique',
		Namibia: 'Namibia',
		'New Zealand': 'New Zealand',
		Niger: 'Niger',
		Nigeria: 'Nigeria',
		'North Macedonia': 'North Macedonia',
		Oman: 'Oman',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paraguay',
		Peru: 'Peru',
		Philippines: 'Philippines',
		Qatar: 'Qatar',
		Rwanda: 'Rwanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Saudi Arabia',
		Senegal: 'Senegal',
		Serbia: 'Serbia',
		Singapore: 'Singapore',
		Slovenia: 'Slovenia',
		'South Africa': 'South Africa',
		'South Korea': 'South Korea',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'St. Lucia',
		Taiwan: 'Taiwan',
		Tanzania: 'Tanzania',
		Thailand: 'Thailand',
		'Trinidad & Tobago': 'Trinidad & Tobago',
		Tunisia: 'Tunisia',
		Turkey: 'Turkey',
		'United Arab Emirates': 'United Arab Emirates',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Uzbekistan',
		Vietnam: 'Vietnam',
		'United States': 'United States',
		Brazil: 'Brazil',
	},
	bg: {
		France: 'Франция',
		Austria: 'Австрия',
		Belgium: 'Белгия',
		Bulgaria: 'България',
		Croatia: 'Хърватия',
		Cyprus: 'Кипър',
		'Czech Republic': 'Чехия',
		Denmark: 'Дания',
		Estonia: 'Естония',
		Finland: 'Финландия',
		Germany: 'Германия',
		Gibraltar: 'Гибралтар',
		Greece: 'Гърция',
		Hungary: 'Унгария',
		Ireland: 'Ирландия',
		Italy: 'Италия',
		Latvia: 'Латвия',
		Liechtenstein: 'Лихтенщайн',
		Lithuania: 'Литва',
		Luxembourg: 'Люксембург',
		Malta: 'Малта',
		Netherlands: 'Нидерландия',
		Norway: 'Норвегия',
		Poland: 'Полша',
		Portugal: 'Португалия',
		Romania: 'Румъния',
		Slovakia: 'Словакия',
		Spain: 'Испания',
		Sweden: 'Швеция',
		Switzerland: 'Швейцария',
		'United Kingdom': 'Обединено кралство',
		'Dominican Republic': 'Доминиканска република',
		Albania: 'Албания',
		Algeria: 'Алжир',
		Angola: 'Ангола',
		'Antigua & Barbuda': 'Антигуа и Барбуда',
		Argentina: 'Аржентина',
		Armenia: 'Армения',
		Australia: 'Австралия',
		Azerbaijan: 'Азербайджан',
		Bahamas: 'Бахамски острови',
		Bahrain: 'Бахрейн',
		Bangladesh: 'Бангладеш',
		Benin: 'Бенин',
		Bhutan: 'Бутан',
		Bolivia: 'Боливия',
		'Bosnia & Herzegovina': 'Босна и Херцеговина',
		Botswana: 'Ботсвана',
		Brunei: 'Бруней',
		Cambodia: 'Камбоджа',
		Canada: 'Канада',
		Chile: 'Чили',
		Colombia: 'Колумбия',
		'Costa Rica': 'Коста Рика',
		'Côte d’Ivoire': "Кот д'Ивоар",
		Ecuador: 'Еквадор',
		Egypt: 'Египет',
		'El Salvador': 'Ел Салвадор',
		Ethiopia: 'Етиопия',
		Gabon: 'Габон',
		Gambia: 'Гамбия',
		Ghana: 'Гана',
		Guatemala: 'Гватемала',
		Guyana: 'Гвиана',
		'Hong Kong': 'Хонконг',
		Indonesia: 'Индонезия',
		Israel: 'Израел',
		Jamaica: 'Ямайка',
		Japan: 'Япония',
		Jordan: 'Йордания',
		Kazakhstan: 'Казахстан',
		Kenya: 'Кения',
		Kuwait: 'Кувейт',
		Laos: 'Лаос',
		'Macao SAR China': 'Макао',
		Madagascar: 'Мадагаскар',
		Malaysia: 'Малайзия',
		Mauritius: 'Мавриций',
		Mexico: 'Мексико',
		Moldova: 'Молдова',
		Monaco: 'Монако',
		Mongolia: 'Монголия',
		Morocco: 'Мароко',
		Mozambique: 'Мозамбик',
		Namibia: 'Намибия',
		'New Zealand': 'Нова Зеландия',
		Niger: 'Нигер',
		Nigeria: 'Нигерия',
		'North Macedonia': 'Северна Македония',
		Oman: 'Оман',
		Pakistan: 'Пакистан',
		Panama: 'Панама',
		Paraguay: 'Парагвай',
		Peru: 'Перу',
		Philippines: 'Филипини',
		Qatar: 'Катар',
		Rwanda: 'Руанда',
		'San Marino': 'Сан Марино',
		'Saudi Arabia': 'Саудитска Арабия',
		Senegal: 'Сенегал',
		Serbia: 'Сърбия',
		Singapore: 'Сингапур',
		Slovenia: 'Словения',
		'South Africa': 'Южна Африка',
		'South Korea': 'Южна Корея',
		'Sri Lanka': 'Шри Ланка',
		'St. Lucia': 'Сейнт Лусия',
		Taiwan: 'Тайван',
		Tanzania: 'Танзания',
		Thailand: 'Тайланд',
		'Trinidad & Tobago': 'Тринидад и Тобаго',
		Tunisia: 'Тунис',
		Turkey: 'Турция',
		'United Arab Emirates': 'Обединени арабски емирства',
		Uruguay: 'Уругвай',
		Uzbekistan: 'Узбекистан',
		Vietnam: 'Виетнам',
		'United States': 'Съединени щати',
		Brazil: 'Бразилия',
	},
	hr: {
		France: 'Francuska',
		Austria: 'Austrija',
		Belgium: 'Belgija',
		Bulgaria: 'Bugarska',
		Croatia: 'Hrvatska',
		Cyprus: 'Cipar',
		'Czech Republic': 'Češka',
		Denmark: 'Danska',
		Estonia: 'Estonija',
		Finland: 'Finska',
		Germany: 'Njemačka',
		Gibraltar: 'Gibraltar',
		Greece: 'Grčka',
		Hungary: 'Mađarska',
		Ireland: 'Irska',
		Italy: 'Italija',
		Latvia: 'Latvija',
		Liechtenstein: 'Lihtenštajn',
		Lithuania: 'Litva',
		Luxembourg: 'Luksemburg',
		Malta: 'Malta',
		Netherlands: 'Nizozemska',
		Norway: 'Norveška',
		Poland: 'Poljska',
		Portugal: 'Portugal',
		Romania: 'Rumunjska',
		Slovakia: 'Slovačka',
		Spain: 'Španjolska',
		Sweden: 'Švedska',
		Switzerland: 'Švicarska',
		'United Kingdom': 'Ujedinjeno Kraljevstvo',
		'Dominican Republic': 'Dominikanska Republika',
		Albania: 'Albanija',
		Algeria: 'Alžir',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigva i Barbuda',
		Argentina: 'Argentina',
		Armenia: 'Armenija',
		Australia: 'Australija',
		Azerbaijan: 'Azerbajdžan',
		Bahamas: 'Bahami',
		Bahrain: 'Bahrein',
		Bangladesh: 'Bangladeš',
		Benin: 'Benin',
		Bhutan: 'Butan',
		Bolivia: 'Bolivija',
		'Bosnia & Herzegovina': 'Bosna i Hercegovina',
		Botswana: 'Bocvana',
		Brunei: 'Brunej',
		Cambodia: 'Kambodža',
		Canada: 'Kanada',
		Chile: 'Čile',
		Colombia: 'Kolumbija',
		'Costa Rica': 'Kostarika',
		'Côte d’Ivoire': 'Obala Bjelokosti',
		Ecuador: 'Ekvador',
		Egypt: 'Egipat',
		'El Salvador': 'Salvador',
		Ethiopia: 'Etiopija',
		Gabon: 'Gabon',
		Gambia: 'Gambija',
		Ghana: 'Gana',
		Guatemala: 'Gvatemala',
		Guyana: 'Gvajana',
		'Hong Kong': 'Hong Kong',
		Indonesia: 'Indonezija',
		Israel: 'Izrael',
		Jamaica: 'Jamajka',
		Japan: 'Japan',
		Jordan: 'Jordan',
		Kazakhstan: 'Kazahstan',
		Kenya: 'Kenija',
		Kuwait: 'Kuvajt',
		Laos: 'Laos',
		'Macao SAR China': 'Makao',
		Madagascar: 'Madagaskar',
		Malaysia: 'Malezija',
		Mauritius: 'Mauricijus',
		Mexico: 'Meksiko',
		Moldova: 'Moldavija',
		Monaco: 'Monako',
		Mongolia: 'Mongolija',
		Morocco: 'Maroko',
		Mozambique: 'Mozambik',
		Namibia: 'Namibija',
		'New Zealand': 'Novi Zeland',
		Niger: 'Niger',
		Nigeria: 'Nigerija',
		'North Macedonia': 'Sjeverna Makedonija',
		Oman: 'Oman',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paragvaj',
		Peru: 'Peru',
		Philippines: 'Filipini',
		Qatar: 'Katar',
		Rwanda: 'Ruanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Saudijska Arabija',
		Senegal: 'Senegal',
		Serbia: 'Srbija',
		Singapore: 'Singapur',
		Slovenia: 'Slovenija',
		'South Africa': 'Južna Afrika',
		'South Korea': 'Južna Koreja',
		'Sri Lanka': 'Šri Lanka',
		'St. Lucia': 'Sveta Lucija',
		Taiwan: 'Tajvan',
		Tanzania: 'Tanzanija',
		Thailand: 'Tajland',
		'Trinidad & Tobago': 'Trinidad i Tobago',
		Tunisia: 'Tunis',
		Turkey: 'Turska',
		'United Arab Emirates': 'Ujedinjeni Arapski Emirati',
		Uruguay: 'Urugvaj',
		Uzbekistan: 'Uzbekistan',
		Vietnam: 'Vijetnam',
		'United States': 'Sjedinjene Američke Države',
		Brazil: 'Brazil',
	},
	cs: {
		France: 'Francie',
		Austria: 'Rakousko',
		Belgium: 'Belgie',
		Bulgaria: 'Bulharsko',
		Croatia: 'Chorvatsko',
		Cyprus: 'Kypr',
		'Czech Republic': 'Česká republika',
		Denmark: 'Dánsko',
		Estonia: 'Estonsko',
		Finland: 'Finsko',
		Germany: 'Německo',
		Gibraltar: 'Gibraltar',
		Greece: 'Řecko',
		Hungary: 'Maďarsko',
		Ireland: 'Irsko',
		Italy: 'Itálie',
		Latvia: 'Lotyšsko',
		Liechtenstein: 'Lichtenštejnsko',
		Lithuania: 'Litva',
		Luxembourg: 'Lucembursko',
		Malta: 'Malta',
		Netherlands: 'Nizozemsko',
		Norway: 'Norsko',
		Poland: 'Polsko',
		Portugal: 'Portugalsko',
		Romania: 'Rumunsko',
		Slovakia: 'Slovensko',
		Spain: 'Španělsko',
		Sweden: 'Švédsko',
		Switzerland: 'Švýcarsko',
		'United Kingdom': 'Spojené království',
		'Dominican Republic': 'Dominikánská republika',
		Albania: 'Albánie',
		Algeria: 'Alžírsko',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua a Barbuda',
		Argentina: 'Argentina',
		Armenia: 'Arménie',
		Australia: 'Austrálie',
		Azerbaijan: 'Ázerbájdžán',
		Bahamas: 'Bahamy',
		Bahrain: 'Bahrajn',
		Bangladesh: 'Bangladéš',
		Benin: 'Benin',
		Bhutan: 'Bhútán',
		Bolivia: 'Bolívie',
		'Bosnia & Herzegovina': 'Bosna a Hercegovina',
		Botswana: 'Botswana',
		Brunei: 'Brunej',
		Cambodia: 'Kambodža',
		Canada: 'Kanada',
		Chile: 'Chile',
		Colombia: 'Kolumbie',
		'Costa Rica': 'Kostarika',
		'Côte d’Ivoire': 'Pobřeží slonoviny',
		Ecuador: 'Ekvádor',
		Egypt: 'Egypt',
		'El Salvador': 'Salvador',
		Ethiopia: 'Etiopie',
		Gabon: 'Gabon',
		Gambia: 'Gambie',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hongkong',
		Indonesia: 'Indonésie',
		Israel: 'Izrael',
		Jamaica: 'Jamajka',
		Japan: 'Japonsko',
		Jordan: 'Jordánsko',
		Kazakhstan: 'Kazachstán',
		Kenya: 'Keňa',
		Kuwait: 'Kuvajt',
		Laos: 'Laos',
		'Macao SAR China': 'Macao',
		Madagascar: 'Madagaskar',
		Malaysia: 'Malajsie',
		Mauritius: 'Mauricius',
		Mexico: 'Mexiko',
		Moldova: 'Moldavsko',
		Monaco: 'Monako',
		Mongolia: 'Mongolsko',
		Morocco: 'Maroko',
		Mozambique: 'Mosambik',
		Namibia: 'Namibie',
		'New Zealand': 'Nový Zéland',
		Niger: 'Niger',
		Nigeria: 'Nigérie',
		'North Macedonia': 'Severní Makedonie',
		Oman: 'Omán',
		Pakistan: 'Pákistán',
		Panama: 'Panama',
		Paraguay: 'Paraguay',
		Peru: 'Peru',
		Philippines: 'Filipíny',
		Qatar: 'Katar',
		Rwanda: 'Rwanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Saúdská Arábie',
		Senegal: 'Senegal',
		Serbia: 'Srbsko',
		Singapore: 'Singapur',
		Slovenia: 'Slovinsko',
		'South Africa': 'Jihoafrická republika',
		'South Korea': 'Jižní Korea',
		'Sri Lanka': 'Srí Lanka',
		'St. Lucia': 'Svatá Lucie',
		Taiwan: 'Tchaj-wan',
		Tanzania: 'Tanzanie',
		Thailand: 'Thajsko',
		'Trinidad & Tobago': 'Trinidad a Tobago',
		Tunisia: 'Tunisko',
		Turkey: 'Turecko',
		'United Arab Emirates': 'Spojené arabské emiráty',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Uzbekistán',
		Vietnam: 'Vietnam',
		'United States': 'Spojené státy',
		Brazil: 'Brazílie',
	},
	da: {
		France: 'Frankrig',
		Austria: 'Østrig',
		Belgium: 'Belgien',
		Bulgaria: 'Bulgarien',
		Croatia: 'Kroatien',
		Cyprus: 'Cypern',
		'Czech Republic': 'Tjekkiet',
		Denmark: 'Danmark',
		Estonia: 'Estland',
		Finland: 'Finland',
		Germany: 'Tyskland',
		Gibraltar: 'Gibraltar',
		Greece: 'Grækenland',
		Hungary: 'Ungarn',
		Ireland: 'Irland',
		Italy: 'Italien',
		Latvia: 'Letland',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Litauen',
		Luxembourg: 'Luxembourg',
		Malta: 'Malta',
		Netherlands: 'Holland',
		Norway: 'Norge',
		Poland: 'Polen',
		Portugal: 'Portugal',
		Romania: 'Rumænien',
		Slovakia: 'Slovakiet',
		Spain: 'Spanien',
		Sweden: 'Sverige',
		Switzerland: 'Schweiz',
		'United Kingdom': 'Storbritannien',
		'Dominican Republic': 'Den Dominikanske Republik',
		Albania: 'Albanien',
		Algeria: 'Algeriet',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua og Barbuda',
		Argentina: 'Argentina',
		Armenia: 'Armenien',
		Australia: 'Australien',
		Azerbaijan: 'Aserbajdsjan',
		Bahamas: 'Bahamas',
		Bahrain: 'Bahrain',
		Bangladesh: 'Bangladesh',
		Benin: 'Benin',
		Bhutan: 'Bhutan',
		Bolivia: 'Bolivia',
		'Bosnia & Herzegovina': 'Bosnien og Hercegovina',
		Botswana: 'Botswana',
		Brunei: 'Brunei',
		Cambodia: 'Cambodja',
		Canada: 'Canada',
		Chile: 'Chile',
		Colombia: 'Colombia',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': 'Elfenbenskysten',
		Ecuador: 'Ecuador',
		Egypt: 'Egypten',
		'El Salvador': 'El Salvador',
		Ethiopia: 'Etiopien',
		Gabon: 'Gabon',
		Gambia: 'Gambia',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hongkong',
		Indonesia: 'Indonesien',
		Israel: 'Israel',
		Jamaica: 'Jamaica',
		Japan: 'Japan',
		Jordan: 'Jordan',
		Kazakhstan: 'Kasakhstan',
		Kenya: 'Kenya',
		Kuwait: 'Kuwait',
		Laos: 'Laos',
		'Macao SAR China': 'Macao',
		Madagascar: 'Madagaskar',
		Malaysia: 'Malaysia',
		Mauritius: 'Mauritius',
		Mexico: 'Mexico',
		Moldova: 'Moldova',
		Monaco: 'Monaco',
		Mongolia: 'Mongoliet',
		Morocco: 'Marokko',
		Mozambique: 'Mozambique',
		Namibia: 'Namibia',
		'New Zealand': 'New Zealand',
		Niger: 'Niger',
		Nigeria: 'Nigeria',
		'North Macedonia': 'Nordmakedonien',
		Oman: 'Oman',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paraguay',
		Peru: 'Peru',
		Philippines: 'Filippinerne',
		Qatar: 'Qatar',
		Rwanda: 'Rwanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Saudi-Arabien',
		Senegal: 'Senegal',
		Serbia: 'Serbien',
		Singapore: 'Singapore',
		Slovenia: 'Slovenien',
		'South Africa': 'Sydafrika',
		'South Korea': 'Sydkorea',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'Saint Lucia',
		Taiwan: 'Taiwan',
		Tanzania: 'Tanzania',
		Thailand: 'Thailand',
		'Trinidad & Tobago': 'Trinidad og Tobago',
		Tunisia: 'Tunesien',
		Turkey: 'Tyrkiet',
		'United Arab Emirates': 'De Forenede Arabiske Emirater',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Usbekistan',
		Vietnam: 'Vietnam',
		'United States': 'USA',
		Brazil: 'Brasilien',
	},
	fi: {
		France: 'Ranska',
		Austria: 'Itävalta',
		Belgium: 'Belgia',
		Bulgaria: 'Bulgaria',
		Croatia: 'Kroatia',
		Cyprus: 'Kypros',
		'Czech Republic': 'Tšekki',
		Denmark: 'Tanska',
		Estonia: 'Viro',
		Finland: 'Suomi',
		Germany: 'Saksa',
		Gibraltar: 'Gibraltar',
		Greece: 'Kreikka',
		Hungary: 'Unkari',
		Ireland: 'Irlanti',
		Italy: 'Italia',
		Latvia: 'Latvia',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Liettua',
		Luxembourg: 'Luxemburg',
		Malta: 'Malta',
		Netherlands: 'Alankomaat',
		Norway: 'Norja',
		Poland: 'Puola',
		Portugal: 'Portugali',
		Romania: 'Romania',
		Slovakia: 'Slovakia',
		Spain: 'Espanja',
		Sweden: 'Ruotsi',
		Switzerland: 'Sveitsi',
		'United Kingdom': 'Yhdistynyt kuningaskunta',
		'Dominican Republic': 'Dominikaaninen tasavalta',
		Albania: 'Albania',
		Algeria: 'Algeria',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua ja Barbuda',
		Argentina: 'Argentiina',
		Armenia: 'Armenia',
		Australia: 'Australia',
		Azerbaijan: 'Azerbaidžan',
		Bahamas: 'Bahama',
		Bahrain: 'Bahrain',
		Bangladesh: 'Bangladesh',
		Benin: 'Benin',
		Bhutan: 'Bhutan',
		Bolivia: 'Bolivia',
		'Bosnia & Herzegovina': 'Bosnia ja Hertsegovina',
		Botswana: 'Botswana',
		Brunei: 'Brunei',
		Cambodia: 'Kambodža',
		Canada: 'Kanada',
		Chile: 'Chile',
		Colombia: 'Kolumbia',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': 'Norsunluurannikko',
		Ecuador: 'Ecuador',
		Egypt: 'Egypti',
		'El Salvador': 'El Salvador',
		Ethiopia: 'Etiopia',
		Gabon: 'Gabon',
		Gambia: 'Gambia',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hongkong',
		Indonesia: 'Indonesia',
		Israel: 'Israel',
		Jamaica: 'Jamaika',
		Japan: 'Japani',
		Jordan: 'Jordania',
		Kazakhstan: 'Kazakstan',
		Kenya: 'Kenia',
		Kuwait: 'Kuwait',
		Laos: 'Laos',
		'Macao SAR China': 'Macao',
		Madagascar: 'Madagaskar',
		Malaysia: 'Malesia',
		Mauritius: 'Mauritius',
		Mexico: 'Meksiko',
		Moldova: 'Moldova',
		Monaco: 'Monaco',
		Mongolia: 'Mongolia',
		Morocco: 'Marokko',
		Mozambique: 'Mosambik',
		Namibia: 'Namibia',
		'New Zealand': 'Uusi-Seelanti',
		Niger: 'Niger',
		Nigeria: 'Nigeria',
		'North Macedonia': 'Pohjois-Makedonia',
		Oman: 'Oman',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paraguay',
		Peru: 'Peru',
		Philippines: 'Filippiinit',
		Qatar: 'Qatar',
		Rwanda: 'Ruanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Saudi-Arabia',
		Senegal: 'Senegal',
		Serbia: 'Serbia',
		Singapore: 'Singapore',
		Slovenia: 'Slovenia',
		'South Africa': 'Etelä-Afrikka',
		'South Korea': 'Etelä-Korea',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'Saint Lucia',
		Taiwan: 'Taiwan',
		Tanzania: 'Tansania',
		Thailand: 'Thaimaa',
		'Trinidad & Tobago': 'Trinidad ja Tobago',
		Tunisia: 'Tunisia',
		Turkey: 'Turkki',
		'United Arab Emirates': 'Yhdistyneet arabiemiirikunnat',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Uzbekistan',
		Vietnam: 'Vietnam',
		'United States': 'Yhdysvallat',
		Brazil: 'Brasilia',
	},
	el: {
		France: 'Γαλλία',
		Austria: 'Αυστρία',
		Belgium: 'Βέλγιο',
		Bulgaria: 'Βουλγαρία',
		Croatia: 'Κροατία',
		Cyprus: 'Κύπρος',
		'Czech Republic': 'Τσεχία',
		Denmark: 'Δανία',
		Estonia: 'Εσθονία',
		Finland: 'Φινλανδία',
		Germany: 'Γερμανία',
		Gibraltar: 'Γιβραλτάρ',
		Greece: 'Ελλάδα',
		Hungary: 'Ουγγαρία',
		Ireland: 'Ιρλανδία',
		Italy: 'Ιταλία',
		Latvia: 'Λετονία',
		Liechtenstein: 'Λιχτενστάιν',
		Lithuania: 'Λιθουανία',
		Luxembourg: 'Λουξεμβούργο',
		Malta: 'Μάλτα',
		Netherlands: 'Ολλανδία',
		Norway: 'Νορβηγία',
		Poland: 'Πολωνία',
		Portugal: 'Πορτογαλία',
		Romania: 'Ρουμανία',
		Slovakia: 'Σλοβακία',
		Spain: 'Ισπανία',
		Sweden: 'Σουηδία',
		Switzerland: 'Ελβετία',
		'United Kingdom': 'Ηνωμένο Βασίλειο',
		'Dominican Republic': 'Δομινικανή Δημοκρατία',
		Albania: 'Αλβανία',
		Algeria: 'Αλγερία',
		Angola: 'Αγκόλα',
		'Antigua & Barbuda': 'Αντίγκουα και Μπαρμπούντα',
		Argentina: 'Αργεντινή',
		Armenia: 'Αρμενία',
		Australia: 'Αυστραλία',
		Azerbaijan: 'Αζερμπαϊτζάν',
		Bahamas: 'Μπαχάμες',
		Bahrain: 'Μπαχρέιν',
		Bangladesh: 'Μπανγκλαντές',
		Benin: 'Μπενίν',
		Bhutan: 'Μπουτάν',
		Bolivia: 'Βολιβία',
		'Bosnia & Herzegovina': 'Βοσνία και Ερζεγοβίνη',
		Botswana: 'Μποτσουάνα',
		Brunei: 'Μπρουνέι',
		Cambodia: 'Καμπότζη',
		Canada: 'Καναδάς',
		Chile: 'Χιλή',
		Colombia: 'Κολομβία',
		'Costa Rica': 'Κόστα Ρίκα',
		'Côte d’Ivoire': 'Ακτή Ελεφαντοστού',
		Ecuador: 'Εκουαδόρ',
		Egypt: 'Αίγυπτος',
		'El Salvador': 'Ελ Σαλβαδόρ',
		Ethiopia: 'Αιθιοπία',
		Gabon: 'Γκαμπόν',
		Gambia: 'Γκάμπια',
		Ghana: 'Γκάνα',
		Guatemala: 'Γουατεμάλα',
		Guyana: 'Γουιάνα',
		'Hong Kong': 'Χονγκ Κονγκ',
		Indonesia: 'Ινδονησία',
		Israel: 'Ισραήλ',
		Jamaica: 'Τζαμάικα',
		Japan: 'Ιαπωνία',
		Jordan: 'Ιορδανία',
		Kazakhstan: 'Καζακστάν',
		Kenya: 'Κένυα',
		Kuwait: 'Κουβέιτ',
		Laos: 'Λάος',
		'Macao SAR China': 'Μακάο',
		Madagascar: 'Μαδαγασκάρη',
		Malaysia: 'Μαλαισία',
		Mauritius: 'Μαυρίκιος',
		Mexico: 'Μεξικό',
		Moldova: 'Μολδαβία',
		Monaco: 'Μονακό',
		Mongolia: 'Μογγολία',
		Morocco: 'Μαρόκο',
		Mozambique: 'Μοζαμβίκη',
		Namibia: 'Ναμίμπια',
		'New Zealand': 'Νέα Ζηλανδία',
		Niger: 'Νίγηρας',
		Nigeria: 'Νιγηρία',
		'North Macedonia': 'Βόρεια Μακεδονία',
		Oman: 'Ομάν',
		Pakistan: 'Πακιστάν',
		Panama: 'Παναμάς',
		Paraguay: 'Παραγουάη',
		Peru: 'Περού',
		Philippines: 'Φιλιππίνες',
		Qatar: 'Κατάρ',
		Rwanda: 'Ρουάντα',
		'San Marino': 'Άγιος Μαρίνος',
		'Saudi Arabia': 'Σαουδική Αραβία',
		Senegal: 'Σενεγάλη',
		Serbia: 'Σερβία',
		Singapore: 'Σιγκαπούρη',
		Slovenia: 'Σλοβενία',
		'South Africa': 'Νότια Αφρική',
		'South Korea': 'Νότια Κορέα',
		'Sri Lanka': 'Σρι Λάνκα',
		'St. Lucia': 'Αγία Λουκία',
		Taiwan: 'Ταϊβάν',
		Tanzania: 'Τανζανία',
		Thailand: 'Ταϊλάνδη',
		'Trinidad & Tobago': 'Τρινιντάντ και Τομπάγκο',
		Tunisia: 'Τυνησία',
		Turkey: 'Τουρκία',
		'United Arab Emirates': 'Ηνωμένα Αραβικά Εμιράτα',
		Uruguay: 'Ουρουγουάη',
		Uzbekistan: 'Ουζμπεκιστάν',
		Vietnam: 'Βιετνάμ',
		'United States': 'Ηνωμένες Πολιτείες',
		Brazil: 'Βραζιλία',
	},
	hu: {
		France: 'Franciaország',
		Austria: 'Ausztria',
		Belgium: 'Belgium',
		Bulgaria: 'Bulgária',
		Croatia: 'Horvátország',
		Cyprus: 'Ciprus',
		'Czech Republic': 'Csehország',
		Denmark: 'Dánia',
		Estonia: 'Észtország',
		Finland: 'Finnország',
		Germany: 'Németország',
		Gibraltar: 'Gibraltár',
		Greece: 'Görögország',
		Hungary: 'Magyarország',
		Ireland: 'Írország',
		Italy: 'Olaszország',
		Latvia: 'Lettország',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Litvánia',
		Luxembourg: 'Luxemburg',
		Malta: 'Málta',
		Netherlands: 'Hollandia',
		Norway: 'Norvégia',
		Poland: 'Lengyelország',
		Portugal: 'Portugália',
		Romania: 'Románia',
		Slovakia: 'Szlovákia',
		Spain: 'Spanyolország',
		Sweden: 'Svédország',
		Switzerland: 'Svájc',
		'United Kingdom': 'Egyesült Királyság',
		'Dominican Republic': 'Dominikai Köztársaság',
		Albania: 'Albánia',
		Algeria: 'Algéria',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua és Barbuda',
		Argentina: 'Argentína',
		Armenia: 'Örményország',
		Australia: 'Ausztrália',
		Azerbaijan: 'Azerbajdzsán',
		Bahamas: 'Bahama-szigetek',
		Bahrain: 'Bahrein',
		Bangladesh: 'Banglades',
		Benin: 'Benin',
		Bhutan: 'Bhután',
		Bolivia: 'Bolívia',
		'Bosnia & Herzegovina': 'Bosznia és Hercegovina',
		Botswana: 'Botswana',
		Brunei: 'Brunei',
		Cambodia: 'Kambodzsa',
		Canada: 'Kanada',
		Chile: 'Chile',
		Colombia: 'Kolumbia',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': 'Elefántcsontpart',
		Ecuador: 'Ecuador',
		Egypt: 'Egyiptom',
		'El Salvador': 'Salvador',
		Ethiopia: 'Etiópia',
		Gabon: 'Gabon',
		Gambia: 'Gambia',
		Ghana: 'Ghána',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hongkong',
		Indonesia: 'Indonézia',
		Israel: 'Izrael',
		Jamaica: 'Jamaica',
		Japan: 'Japán',
		Jordan: 'Jordánia',
		Kazakhstan: 'Kazahsztán',
		Kenya: 'Kenya',
		Kuwait: 'Kuvait',
		Laos: 'Laosz',
		'Macao SAR China': 'Makaó',
		Madagascar: 'Madagaszkár',
		Malaysia: 'Malajzia',
		Mauritius: 'Mauritius',
		Mexico: 'Mexikó',
		Moldova: 'Moldova',
		Monaco: 'Monaco',
		Mongolia: 'Mongólia',
		Morocco: 'Marokkó',
		Mozambique: 'Mozambik',
		Namibia: 'Namíbia',
		'New Zealand': 'Új-Zéland',
		Niger: 'Niger',
		Nigeria: 'Nigéria',
		'North Macedonia': 'Észak-Macedónia',
		Oman: 'Omán',
		Pakistan: 'Pakisztán',
		Panama: 'Panama',
		Paraguay: 'Paraguay',
		Peru: 'Peru',
		Philippines: 'Fülöp-szigetek',
		Qatar: 'Katar',
		Rwanda: 'Ruanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Szaúd-Arábia',
		Senegal: 'Szenegál',
		Serbia: 'Szerbia',
		Singapore: 'Szingapúr',
		Slovenia: 'Szlovénia',
		'South Africa': 'Dél-Afrika',
		'South Korea': 'Dél-Korea',
		'Sri Lanka': 'Srí Lanka',
		'St. Lucia': 'Saint Lucia',
		Taiwan: 'Tajvan',
		Tanzania: 'Tanzánia',
		Thailand: 'Thaiföld',
		'Trinidad & Tobago': 'Trinidad és Tobago',
		Tunisia: 'Tunézia',
		Turkey: 'Törökország',
		'United Arab Emirates': 'Egyesült Arab Emírségek',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Üzbegisztán',
		Vietnam: 'Vietnám',
		'United States': 'Egyesült Államok',
		Brazil: 'Brazília',
	},
	it: {
		France: 'Francia',
		Austria: 'Austria',
		Belgium: 'Belgio',
		Bulgaria: 'Bulgaria',
		Croatia: 'Croazia',
		Cyprus: 'Cipro',
		'Czech Republic': 'Repubblica Ceca',
		Denmark: 'Danimarca',
		Estonia: 'Estonia',
		Finland: 'Finlandia',
		Germany: 'Germania',
		Gibraltar: 'Gibilterra',
		Greece: 'Grecia',
		Hungary: 'Ungheria',
		Ireland: 'Irlanda',
		Italy: 'Italia',
		Latvia: 'Lettonia',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Lituania',
		Luxembourg: 'Lussemburgo',
		Malta: 'Malta',
		Netherlands: 'Paesi Bassi',
		Norway: 'Norvegia',
		Poland: 'Polonia',
		Portugal: 'Portogallo',
		Romania: 'Romania',
		Slovakia: 'Slovacchia',
		Spain: 'Spagna',
		Sweden: 'Svezia',
		Switzerland: 'Svizzera',
		'United Kingdom': 'Regno Unito',
		'Dominican Republic': 'Repubblica Dominicana',
		Albania: 'Albania',
		Algeria: 'Algeria',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua e Barbuda',
		Argentina: 'Argentina',
		Armenia: 'Armenia',
		Australia: 'Australia',
		Azerbaijan: 'Azerbaigian',
		Bahamas: 'Bahamas',
		Bahrain: 'Bahrein',
		Bangladesh: 'Bangladesh',
		Benin: 'Benin',
		Bhutan: 'Bhutan',
		Bolivia: 'Bolivia',
		'Bosnia & Herzegovina': 'Bosnia ed Erzegovina',
		Botswana: 'Botswana',
		Brunei: 'Brunei',
		Cambodia: 'Cambogia',
		Canada: 'Canada',
		Chile: 'Cile',
		Colombia: 'Colombia',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': "Costa d'Avorio",
		Ecuador: 'Ecuador',
		Egypt: 'Egitto',
		'El Salvador': 'El Salvador',
		Ethiopia: 'Etiopia',
		Gabon: 'Gabon',
		Gambia: 'Gambia',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hong Kong',
		Indonesia: 'Indonesia',
		Israel: 'Israele',
		Jamaica: 'Giamaica',
		Japan: 'Giappone',
		Jordan: 'Giordania',
		Kazakhstan: 'Kazakistan',
		Kenya: 'Kenya',
		Kuwait: 'Kuwait',
		Laos: 'Laos',
		'Macao SAR China': 'Macao',
		Madagascar: 'Madagascar',
		Malaysia: 'Malesia',
		Mauritius: 'Mauritius',
		Mexico: 'Messico',
		Moldova: 'Moldavia',
		Monaco: 'Monaco',
		Mongolia: 'Mongolia',
		Morocco: 'Marocco',
		Mozambique: 'Mozambico',
		Namibia: 'Namibia',
		'New Zealand': 'Nuova Zelanda',
		Niger: 'Niger',
		Nigeria: 'Nigeria',
		'North Macedonia': 'Macedonia del Nord',
		Oman: 'Oman',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paraguay',
		Peru: 'Perù',
		Philippines: 'Filippine',
		Qatar: 'Qatar',
		Rwanda: 'Ruanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Arabia Saudita',
		Senegal: 'Senegal',
		Serbia: 'Serbia',
		Singapore: 'Singapore',
		Slovenia: 'Slovenia',
		'South Africa': 'Sudafrica',
		'South Korea': 'Corea del Sud',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'Saint Lucia',
		Taiwan: 'Taiwan',
		Tanzania: 'Tanzania',
		Thailand: 'Thailandia',
		'Trinidad & Tobago': 'Trinidad e Tobago',
		Tunisia: 'Tunisia',
		Turkey: 'Turchia',
		'United Arab Emirates': 'Emirati Arabi Uniti',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Uzbekistan',
		Vietnam: 'Vietnam',
		'United States': 'Stati Uniti',
		Brazil: 'Brasile',
	},
	pl: {
		France: 'Francja',
		Austria: 'Austria',
		Belgium: 'Belgia',
		Bulgaria: 'Bułgaria',
		Croatia: 'Chorwacja',
		Cyprus: 'Cypr',
		'Czech Republic': 'Czechy',
		Denmark: 'Dania',
		Estonia: 'Estonia',
		Finland: 'Finlandia',
		Germany: 'Niemcy',
		Gibraltar: 'Gibraltar',
		Greece: 'Grecja',
		Hungary: 'Węgry',
		Ireland: 'Irlandia',
		Italy: 'Włochy',
		Latvia: 'Łotwa',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Litwa',
		Luxembourg: 'Luksemburg',
		Malta: 'Malta',
		Netherlands: 'Holandia',
		Norway: 'Norwegia',
		Poland: 'Polska',
		Portugal: 'Portugalia',
		Romania: 'Rumunia',
		Slovakia: 'Słowacja',
		Spain: 'Hiszpania',
		Sweden: 'Szwecja',
		Switzerland: 'Szwajcaria',
		'United Kingdom': 'Wielka Brytania',
		'Dominican Republic': 'Dominikana',
		Albania: 'Albania',
		Algeria: 'Algieria',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua i Barbuda',
		Argentina: 'Argentyna',
		Armenia: 'Armenia',
		Australia: 'Australia',
		Azerbaijan: 'Azerbejdżan',
		Bahamas: 'Bahamy',
		Bahrain: 'Bahrajn',
		Bangladesh: 'Bangladesz',
		Benin: 'Benin',
		Bhutan: 'Bhutan',
		Bolivia: 'Boliwia',
		'Bosnia & Herzegovina': 'Bośnia i Hercegowina',
		Botswana: 'Botswana',
		Brunei: 'Brunei',
		Cambodia: 'Kambodża',
		Canada: 'Kanada',
		Chile: 'Chile',
		Colombia: 'Kolumbia',
		'Costa Rica': 'Kostaryka',
		'Côte d’Ivoire': 'Wybrzeże Kości Słoniowej',
		Ecuador: 'Ekwador',
		Egypt: 'Egipt',
		'El Salvador': 'Salwador',
		Ethiopia: 'Etiopia',
		Gabon: 'Gabon',
		Gambia: 'Gambia',
		Ghana: 'Ghana',
		Guatemala: 'Gwatemala',
		Guyana: 'Gujana',
		'Hong Kong': 'Hongkong',
		Indonesia: 'Indonezja',
		Israel: 'Izrael',
		Jamaica: 'Jamajka',
		Japan: 'Japonia',
		Jordan: 'Jordania',
		Kazakhstan: 'Kazachstan',
		Kenya: 'Kenia',
		Kuwait: 'Kuwejt',
		Laos: 'Laos',
		'Macao SAR China': 'Makau',
		Madagascar: 'Madagaskar',
		Malaysia: 'Malezja',
		Mauritius: 'Mauritius',
		Mexico: 'Meksyk',
		Moldova: 'Mołdawia',
		Monaco: 'Monako',
		Mongolia: 'Mongolia',
		Morocco: 'Maroko',
		Mozambique: 'Mozambik',
		Namibia: 'Namibia',
		'New Zealand': 'Nowa Zelandia',
		Niger: 'Niger',
		Nigeria: 'Nigeria',
		'North Macedonia': 'Macedonia Północna',
		Oman: 'Oman',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paragwaj',
		Peru: 'Peru',
		Philippines: 'Filipiny',
		Qatar: 'Katar',
		Rwanda: 'Rwanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Arabia Saudyjska',
		Senegal: 'Senegal',
		Serbia: 'Serbia',
		Singapore: 'Singapur',
		Slovenia: 'Słowenia',
		'South Africa': 'Republika Południowej Afryki',
		'South Korea': 'Korea Południowa',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'Saint Lucia',
		Taiwan: 'Tajwan',
		Tanzania: 'Tanzania',
		Thailand: 'Tajlandia',
		'Trinidad & Tobago': 'Trynidad i Tobago',
		Tunisia: 'Tunezja',
		Turkey: 'Turcja',
		'United Arab Emirates': 'Zjednoczone Emiraty Arabskie',
		Uruguay: 'Urugwaj',
		Uzbekistan: 'Uzbekistan',
		Vietnam: 'Wietnam',
		'United States': 'Stany Zjednoczone',
		Brazil: 'Brazylia',
	},
	pt: {
		France: 'França',
		Austria: 'Áustria',
		Belgium: 'Bélgica',
		Bulgaria: 'Bulgária',
		Croatia: 'Croácia',
		Cyprus: 'Chipre',
		'Czech Republic': 'República Tcheca',
		Denmark: 'Dinamarca',
		Estonia: 'Estônia',
		Finland: 'Finlândia',
		Germany: 'Alemanha',
		Gibraltar: 'Gibraltar',
		Greece: 'Grécia',
		Hungary: 'Hungria',
		Ireland: 'Irlanda',
		Italy: 'Itália',
		Latvia: 'Letônia',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Lituânia',
		Luxembourg: 'Luxemburgo',
		Malta: 'Malta',
		Netherlands: 'Países Baixos',
		Norway: 'Noruega',
		Poland: 'Polônia',
		Portugal: 'Portugal',
		Romania: 'Romênia',
		Slovakia: 'Eslováquia',
		Spain: 'Espanha',
		Sweden: 'Suécia',
		Switzerland: 'Suíça',
		'United Kingdom': 'Reino Unido',
		'Dominican Republic': 'República Dominicana',
		Albania: 'Albânia',
		Algeria: 'Argélia',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antígua e Barbuda',
		Argentina: 'Argentina',
		Armenia: 'Armênia',
		Australia: 'Austrália',
		Azerbaijan: 'Azerbaijão',
		Bahamas: 'Bahamas',
		Bahrain: 'Bahrein',
		Bangladesh: 'Bangladesh',
		Benin: 'Benin',
		Bhutan: 'Butão',
		Bolivia: 'Bolívia',
		'Bosnia & Herzegovina': 'Bósnia e Herzegovina',
		Botswana: 'Botsuana',
		Brunei: 'Brunei',
		Cambodia: 'Camboja',
		Canada: 'Canadá',
		Chile: 'Chile',
		Colombia: 'Colômbia',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': 'Costa do Marfim',
		Ecuador: 'Equador',
		Egypt: 'Egito',
		'El Salvador': 'El Salvador',
		Ethiopia: 'Etiópia',
		Gabon: 'Gabão',
		Gambia: 'Gâmbia',
		Ghana: 'Gana',
		Guatemala: 'Guatemala',
		Guyana: 'Guiana',
		'Hong Kong': 'Hong Kong',
		Indonesia: 'Indonésia',
		Israel: 'Israel',
		Jamaica: 'Jamaica',
		Japan: 'Japão',
		Jordan: 'Jordânia',
		Kazakhstan: 'Cazaquistão',
		Kenya: 'Quênia',
		Kuwait: 'Kuwait',
		Laos: 'Laos',
		'Macao SAR China': 'Macau',
		Madagascar: 'Madagascar',
		Malaysia: 'Malásia',
		Mauritius: 'Maurício',
		Mexico: 'México',
		Moldova: 'Moldávia',
		Monaco: 'Mônaco',
		Mongolia: 'Mongólia',
		Morocco: 'Marrocos',
		Mozambique: 'Moçambique',
		Namibia: 'Namíbia',
		'New Zealand': 'Nova Zelândia',
		Niger: 'Níger',
		Nigeria: 'Nigéria',
		'North Macedonia': 'Macedônia do Norte',
		Oman: 'Omã',
		Pakistan: 'Paquistão',
		Panama: 'Panamá',
		Paraguay: 'Paraguai',
		Peru: 'Peru',
		Philippines: 'Filipinas',
		Qatar: 'Catar',
		Rwanda: 'Ruanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Arábia Saudita',
		Senegal: 'Senegal',
		Serbia: 'Sérvia',
		Singapore: 'Singapura',
		Slovenia: 'Eslovênia',
		'South Africa': 'África do Sul',
		'South Korea': 'Coreia do Sul',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'Santa Lúcia',
		Taiwan: 'Taiwan',
		Tanzania: 'Tanzânia',
		Thailand: 'Tailândia',
		'Trinidad & Tobago': 'Trinidad e Tobago',
		Tunisia: 'Tunísia',
		Turkey: 'Turquia',
		'United Arab Emirates': 'Emirados Árabes Unidos',
		Uruguay: 'Uruguai',
		Uzbekistan: 'Uzbequistão',
		Vietnam: 'Vietnã',
		'United States': 'Estados Unidos',
		Brazil: 'Brasil',
	},
	ro: {
		France: 'Franța',
		Austria: 'Austria',
		Belgium: 'Belgia',
		Bulgaria: 'Bulgaria',
		Croatia: 'Croația',
		Cyprus: 'Cipru',
		'Czech Republic': 'Republica Cehă',
		Denmark: 'Danemarca',
		Estonia: 'Estonia',
		Finland: 'Finlanda',
		Germany: 'Germania',
		Gibraltar: 'Gibraltar',
		Greece: 'Grecia',
		Hungary: 'Ungaria',
		Ireland: 'Irlanda',
		Italy: 'Italia',
		Latvia: 'Letonia',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Lituania',
		Luxembourg: 'Luxemburg',
		Malta: 'Malta',
		Netherlands: 'Țările de Jos',
		Norway: 'Norvegia',
		Poland: 'Polonia',
		Portugal: 'Portugalia',
		Romania: 'România',
		Slovakia: 'Slovacia',
		Spain: 'Spania',
		Sweden: 'Suedia',
		Switzerland: 'Elveția',
		'United Kingdom': 'Regatul Unit',
		'Dominican Republic': 'Republica Dominicană',
		Albania: 'Albania',
		Algeria: 'Algeria',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua și Barbuda',
		Argentina: 'Argentina',
		Armenia: 'Armenia',
		Australia: 'Australia',
		Azerbaijan: 'Azerbaidjan',
		Bahamas: 'Bahamas',
		Bahrain: 'Bahrein',
		Bangladesh: 'Bangladesh',
		Benin: 'Benin',
		Bhutan: 'Bhutan',
		Bolivia: 'Bolivia',
		'Bosnia & Herzegovina': 'Bosnia și Herțegovina',
		Botswana: 'Botswana',
		Brunei: 'Brunei',
		Cambodia: 'Cambodgia',
		Canada: 'Canada',
		Chile: 'Chile',
		Colombia: 'Columbia',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': 'Coasta de Fildeș',
		Ecuador: 'Ecuador',
		Egypt: 'Egipt',
		'El Salvador': 'El Salvador',
		Ethiopia: 'Etiopia',
		Gabon: 'Gabon',
		Gambia: 'Gambia',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hong Kong',
		Indonesia: 'Indonezia',
		Israel: 'Israel',
		Jamaica: 'Jamaica',
		Japan: 'Japonia',
		Jordan: 'Iordania',
		Kazakhstan: 'Kazahstan',
		Kenya: 'Kenya',
		Kuwait: 'Kuweit',
		Laos: 'Laos',
		'Macao SAR China': 'Macao',
		Madagascar: 'Madagascar',
		Malaysia: 'Malaezia',
		Mauritius: 'Mauritius',
		Mexico: 'Mexic',
		Moldova: 'Moldova',
		Monaco: 'Monaco',
		Mongolia: 'Mongolia',
		Morocco: 'Maroc',
		Mozambique: 'Mozambic',
		Namibia: 'Namibia',
		'New Zealand': 'Noua Zeelandă',
		Niger: 'Niger',
		Nigeria: 'Nigeria',
		'North Macedonia': 'Macedonia de Nord',
		Oman: 'Oman',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paraguay',
		Peru: 'Peru',
		Philippines: 'Filipine',
		Qatar: 'Qatar',
		Rwanda: 'Rwanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Arabia Saudită',
		Senegal: 'Senegal',
		Serbia: 'Serbia',
		Singapore: 'Singapore',
		Slovenia: 'Slovenia',
		'South Africa': 'Africa de Sud',
		'South Korea': 'Coreea de Sud',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'Sfânta Lucia',
		Taiwan: 'Taiwan',
		Tanzania: 'Tanzania',
		Thailand: 'Thailanda',
		'Trinidad & Tobago': 'Trinidad și Tobago',
		Tunisia: 'Tunisia',
		Turkey: 'Turcia',
		'United Arab Emirates': 'Emiratele Arabe Unite',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Uzbekistan',
		Vietnam: 'Vietnam',
		'United States': 'Statele Unite',
		Brazil: 'Brazilia',
	},
	sk: {
		France: 'Francúzsko',
		Austria: 'Rakúsko',
		Belgium: 'Belgicko',
		Bulgaria: 'Bulharsko',
		Croatia: 'Chorvátsko',
		Cyprus: 'Cyprus',
		'Czech Republic': 'Česká republika',
		Denmark: 'Dánsko',
		Estonia: 'Estónsko',
		Finland: 'Fínsko',
		Germany: 'Nemecko',
		Gibraltar: 'Gibraltár',
		Greece: 'Grécko',
		Hungary: 'Maďarsko',
		Ireland: 'Írsko',
		Italy: 'Taliansko',
		Latvia: 'Lotyšsko',
		Liechtenstein: 'Lichtenštajnsko',
		Lithuania: 'Litva',
		Luxembourg: 'Luxembursko',
		Malta: 'Malta',
		Netherlands: 'Holandsko',
		Norway: 'Nórsko',
		Poland: 'Poľsko',
		Portugal: 'Portugalsko',
		Romania: 'Rumunsko',
		Slovakia: 'Slovensko',
		Spain: 'Španielsko',
		Sweden: 'Švédsko',
		Switzerland: 'Švajčiarsko',
		'United Kingdom': 'Spojené kráľovstvo',
		'Dominican Republic': 'Dominikánska republika',
		Albania: 'Albánsko',
		Algeria: 'Alžírsko',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua a Barbuda',
		Argentina: 'Argentína',
		Armenia: 'Arménsko',
		Australia: 'Austrália',
		Azerbaijan: 'Azerbajdžan',
		Bahamas: 'Bahamy',
		Bahrain: 'Bahrajn',
		Bangladesh: 'Bangladéš',
		Benin: 'Benin',
		Bhutan: 'Bhután',
		Bolivia: 'Bolívia',
		'Bosnia & Herzegovina': 'Bosna a Hercegovina',
		Botswana: 'Botswana',
		Brunei: 'Brunej',
		Cambodia: 'Kambodža',
		Canada: 'Kanada',
		Chile: 'Čile',
		Colombia: 'Kolumbia',
		'Costa Rica': 'Kostarika',
		'Côte d’Ivoire': 'Pobrežie Slonoviny',
		Ecuador: 'Ekvádor',
		Egypt: 'Egypt',
		'El Salvador': 'Salvádor',
		Ethiopia: 'Etiópia',
		Gabon: 'Gabon',
		Gambia: 'Gambia',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hongkong',
		Indonesia: 'Indonézia',
		Israel: 'Izrael',
		Jamaica: 'Jamajka',
		Japan: 'Japonsko',
		Jordan: 'Jordánsko',
		Kazakhstan: 'Kazachstan',
		Kenya: 'Keňa',
		Kuwait: 'Kuvajt',
		Laos: 'Laos',
		'Macao SAR China': 'Macao',
		Madagascar: 'Madagaskar',
		Malaysia: 'Malajzia',
		Mauritius: 'Maurícius',
		Mexico: 'Mexiko',
		Moldova: 'Moldavsko',
		Monaco: 'Monako',
		Mongolia: 'Mongolsko',
		Morocco: 'Maroko',
		Mozambique: 'Mozambik',
		Namibia: 'Namíbia',
		'New Zealand': 'Nový Zéland',
		Niger: 'Niger',
		Nigeria: 'Nigéria',
		'North Macedonia': 'Severné Macedónsko',
		Oman: 'Omán',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paraguaj',
		Peru: 'Peru',
		Philippines: 'Filipíny',
		Qatar: 'Katar',
		Rwanda: 'Rwanda',
		'San Marino': 'San Maríno',
		'Saudi Arabia': 'Saudská Arábia',
		Senegal: 'Senegal',
		Serbia: 'Srbsko',
		Singapore: 'Singapur',
		Slovenia: 'Slovinsko',
		'South Africa': 'Južná Afrika',
		'South Korea': 'Južná Kórea',
		'Sri Lanka': 'Srí Lanka',
		'St. Lucia': 'Svätá Lucia',
		Taiwan: 'Taiwan',
		Tanzania: 'Tanzánia',
		Thailand: 'Thajsko',
		'Trinidad & Tobago': 'Trinidad a Tobago',
		Tunisia: 'Tunisko',
		Turkey: 'Turecko',
		'United Arab Emirates': 'Spojené arabské emiráty',
		Uruguay: 'Uruguaj',
		Uzbekistan: 'Uzbekistan',
		Vietnam: 'Vietnam',
		'United States': 'Spojené štáty',
		Brazil: 'Brazília',
	},
	sv: {
		France: 'Frankrike',
		Austria: 'Österrike',
		Belgium: 'Belgien',
		Bulgaria: 'Bulgarien',
		Croatia: 'Kroatien',
		Cyprus: 'Cypern',
		'Czech Republic': 'Tjeckien',
		Denmark: 'Danmark',
		Estonia: 'Estland',
		Finland: 'Finland',
		Germany: 'Tyskland',
		Gibraltar: 'Gibraltar',
		Greece: 'Grekland',
		Hungary: 'Ungern',
		Ireland: 'Irland',
		Italy: 'Italien',
		Latvia: 'Lettland',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Litauen',
		Luxembourg: 'Luxemburg',
		Malta: 'Malta',
		Netherlands: 'Nederländerna',
		Norway: 'Norge',
		Poland: 'Polen',
		Portugal: 'Portugal',
		Romania: 'Rumänien',
		Slovakia: 'Slovakien',
		Spain: 'Spanien',
		Sweden: 'Sverige',
		Switzerland: 'Schweiz',
		'United Kingdom': 'Storbritannien',
		'Dominican Republic': 'Dominikanska republiken',
		Albania: 'Albanien',
		Algeria: 'Algeriet',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua och Barbuda',
		Argentina: 'Argentina',
		Armenia: 'Armenien',
		Australia: 'Australien',
		Azerbaijan: 'Azerbajdzjan',
		Bahamas: 'Bahamas',
		Bahrain: 'Bahrain',
		Bangladesh: 'Bangladesh',
		Benin: 'Benin',
		Bhutan: 'Bhutan',
		Bolivia: 'Bolivia',
		'Bosnia & Herzegovina': 'Bosnien och Hercegovina',
		Botswana: 'Botswana',
		Brunei: 'Brunei',
		Cambodia: 'Kambodja',
		Canada: 'Kanada',
		Chile: 'Chile',
		Colombia: 'Colombia',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': 'Elfenbenskusten',
		Ecuador: 'Ecuador',
		Egypt: 'Egypten',
		'El Salvador': 'El Salvador',
		Ethiopia: 'Etiopien',
		Gabon: 'Gabon',
		Gambia: 'Gambia',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hongkong',
		Indonesia: 'Indonesien',
		Israel: 'Israel',
		Jamaica: 'Jamaica',
		Japan: 'Japan',
		Jordan: 'Jordanien',
		Kazakhstan: 'Kazakstan',
		Kenya: 'Kenya',
		Kuwait: 'Kuwait',
		Laos: 'Laos',
		'Macao SAR China': 'Macao',
		Madagascar: 'Madagaskar',
		Malaysia: 'Malaysia',
		Mauritius: 'Mauritius',
		Mexico: 'Mexiko',
		Moldova: 'Moldavien',
		Monaco: 'Monaco',
		Mongolia: 'Mongoliet',
		Morocco: 'Marocko',
		Mozambique: 'Moçambique',
		Namibia: 'Namibia',
		'New Zealand': 'Nya Zeeland',
		Niger: 'Niger',
		Nigeria: 'Nigeria',
		'North Macedonia': 'Nordmakedonien',
		Oman: 'Oman',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paraguay',
		Peru: 'Peru',
		Philippines: 'Filippinerna',
		Qatar: 'Qatar',
		Rwanda: 'Rwanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Saudiarabien',
		Senegal: 'Senegal',
		Serbia: 'Serbien',
		Singapore: 'Singapore',
		Slovenia: 'Slovenien',
		'South Africa': 'Sydafrika',
		'South Korea': 'Sydkorea',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'Saint Lucia',
		Taiwan: 'Taiwan',
		Tanzania: 'Tanzania',
		Thailand: 'Thailand',
		'Trinidad & Tobago': 'Trinidad och Tobago',
		Tunisia: 'Tunisien',
		Turkey: 'Turkiet',
		'United Arab Emirates': 'Förenade Arabemiraten',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Uzbekistan',
		Vietnam: 'Vietnam',
		'United States': 'USA',
		Brazil: 'Brasilien',
	},
	uk: {
		France: 'Франція',
		Austria: 'Австрія',
		Belgium: 'Бельгія',
		Bulgaria: 'Болгарія',
		Croatia: 'Хорватія',
		Cyprus: 'Кіпр',
		'Czech Republic': 'Чехія',
		Denmark: 'Данія',
		Estonia: 'Естонія',
		Finland: 'Фінляндія',
		Germany: 'Німеччина',
		Gibraltar: 'Гібралтар',
		Greece: 'Греція',
		Hungary: 'Угорщина',
		Ireland: 'Ірландія',
		Italy: 'Італія',
		Latvia: 'Латвія',
		Liechtenstein: 'Ліхтенштейн',
		Lithuania: 'Литва',
		Luxembourg: 'Люксембург',
		Malta: 'Мальта',
		Netherlands: 'Нідерланди',
		Norway: 'Норвегія',
		Poland: 'Польща',
		Portugal: 'Португалія',
		Romania: 'Румунія',
		Slovakia: 'Словаччина',
		Spain: 'Іспанія',
		Sweden: 'Швеція',
		Switzerland: 'Швейцарія',
		'United Kingdom': 'Велика Британія',
		'Dominican Republic': 'Домініканська Республіка',
		Albania: 'Албанія',
		Algeria: 'Алжир',
		Angola: 'Ангола',
		'Antigua & Barbuda': 'Антигуа і Барбуда',
		Argentina: 'Аргентина',
		Armenia: 'Вірменія',
		Australia: 'Австралія',
		Azerbaijan: 'Азербайджан',
		Bahamas: 'Багамські Острови',
		Bahrain: 'Бахрейн',
		Bangladesh: 'Бангладеш',
		Benin: 'Бенін',
		Bhutan: 'Бутан',
		Bolivia: 'Болівія',
		'Bosnia & Herzegovina': 'Боснія і Герцеговина',
		Botswana: 'Ботсвана',
		Brunei: 'Бруней',
		Cambodia: 'Камбоджа',
		Canada: 'Канада',
		Chile: 'Чилі',
		Colombia: 'Колумбія',
		'Costa Rica': 'Коста-Рика',
		'Côte d’Ivoire': "Кот-д'Івуар",
		Ecuador: 'Еквадор',
		Egypt: 'Єгипет',
		'El Salvador': 'Сальвадор',
		Ethiopia: 'Ефіопія',
		Gabon: 'Габон',
		Gambia: 'Гамбія',
		Ghana: 'Гана',
		Guatemala: 'Гватемала',
		Guyana: 'Гаяна',
		'Hong Kong': 'Гонконг',
		Indonesia: 'Індонезія',
		Israel: 'Ізраїль',
		Jamaica: 'Ямайка',
		Japan: 'Японія',
		Jordan: 'Йорданія',
		Kazakhstan: 'Казахстан',
		Kenya: 'Кенія',
		Kuwait: 'Кувейт',
		Laos: 'Лаос',
		'Macao SAR China': 'Макао',
		Madagascar: 'Мадагаскар',
		Malaysia: 'Малайзія',
		Mauritius: 'Маврикій',
		Mexico: 'Мексика',
		Moldova: 'Молдова',
		Monaco: 'Монако',
		Mongolia: 'Монголія',
		Morocco: 'Марокко',
		Mozambique: 'Мозамбік',
		Namibia: 'Намібія',
		'New Zealand': 'Нова Зеландія',
		Niger: 'Нігер',
		Nigeria: 'Нігерія',
		'North Macedonia': 'Північна Македонія',
		Oman: 'Оман',
		Pakistan: 'Пакистан',
		Panama: 'Панама',
		Paraguay: 'Парагвай',
		Peru: 'Перу',
		Philippines: 'Філіппіни',
		Qatar: 'Катар',
		Rwanda: 'Руанда',
		'San Marino': 'Сан-Марино',
		'Saudi Arabia': 'Саудівська Аравія',
		Senegal: 'Сенегал',
		Serbia: 'Сербія',
		Singapore: 'Сінгапур',
		Slovenia: 'Словенія',
		'South Africa': 'Південна Африка',
		'South Korea': 'Південна Корея',
		'Sri Lanka': 'Шрі-Ланка',
		'St. Lucia': 'Сент-Люсія',
		Taiwan: 'Тайвань',
		Tanzania: 'Танзанія',
		Thailand: 'Таїланд',
		'Trinidad & Tobago': 'Тринідад і Тобаго',
		Tunisia: 'Туніс',
		Turkey: 'Туреччина',
		'United Arab Emirates': "Об'єднані Арабські Емірати",
		Uruguay: 'Уругвай',
		Uzbekistan: 'Узбекистан',
		Vietnam: "В'єтнам",
		'United States': 'Сполучені Штати',
		Brazil: 'Бразилія',
	},
	nl: {
		France: 'Frankrijk',
		Austria: 'Oostenrijk',
		Belgium: 'België',
		Bulgaria: 'Bulgarije',
		Croatia: 'Kroatië',
		Cyprus: 'Cyprus',
		'Czech Republic': 'Tsjechië',
		Denmark: 'Denemarken',
		Estonia: 'Estland',
		Finland: 'Finland',
		Germany: 'Duitsland',
		Gibraltar: 'Gibraltar',
		Greece: 'Griekenland',
		Hungary: 'Hongarije',
		Ireland: 'Ierland',
		Italy: 'Italië',
		Latvia: 'Letland',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Litouwen',
		Luxembourg: 'Luxemburg',
		Malta: 'Malta',
		Netherlands: 'Nederland',
		Norway: 'Noorwegen',
		Poland: 'Polen',
		Portugal: 'Portugal',
		Romania: 'Roemenië',
		Slovakia: 'Slowakije',
		Spain: 'Spanje',
		Sweden: 'Zweden',
		Switzerland: 'Zwitserland',
		'United Kingdom': 'Verenigd Koninkrijk',
		'Dominican Republic': 'Dominicaanse Republiek',
		Albania: 'Albanië',
		Algeria: 'Algerije',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua en Barbuda',
		Argentina: 'Argentinië',
		Armenia: 'Armenië',
		Australia: 'Australië',
		Azerbaijan: 'Azerbeidzjan',
		Bahamas: "Bahama's",
		Bahrain: 'Bahrein',
		Bangladesh: 'Bangladesh',
		Benin: 'Benin',
		Bhutan: 'Bhutan',
		Bolivia: 'Bolivia',
		'Bosnia & Herzegovina': 'Bosnië en Herzegovina',
		Botswana: 'Botswana',
		Brunei: 'Brunei',
		Cambodia: 'Cambodja',
		Canada: 'Canada',
		Chile: 'Chili',
		Colombia: 'Colombia',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': 'Ivoorkust',
		Ecuador: 'Ecuador',
		Egypt: 'Egypte',
		'El Salvador': 'El Salvador',
		Ethiopia: 'Ethiopië',
		Gabon: 'Gabon',
		Gambia: 'Gambia',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hongkong',
		Indonesia: 'Indonesië',
		Israel: 'Israël',
		Jamaica: 'Jamaica',
		Japan: 'Japan',
		Jordan: 'Jordanië',
		Kazakhstan: 'Kazachstan',
		Kenya: 'Kenia',
		Kuwait: 'Koeweit',
		Laos: 'Laos',
		'Macao SAR China': 'Macau',
		Madagascar: 'Madagaskar',
		Malaysia: 'Maleisië',
		Mauritius: 'Mauritius',
		Mexico: 'Mexico',
		Moldova: 'Moldavië',
		Monaco: 'Monaco',
		Mongolia: 'Mongolië',
		Morocco: 'Marokko',
		Mozambique: 'Mozambique',
		Namibia: 'Namibië',
		'New Zealand': 'Nieuw-Zeeland',
		Niger: 'Niger',
		Nigeria: 'Nigeria',
		'North Macedonia': 'Noord-Macedonië',
		Oman: 'Oman',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paraguay',
		Peru: 'Peru',
		Philippines: 'Filipijnen',
		Qatar: 'Qatar',
		Rwanda: 'Rwanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Saoedi-Arabië',
		Senegal: 'Senegal',
		Serbia: 'Servië',
		Singapore: 'Singapore',
		Slovenia: 'Slovenië',
		'South Africa': 'Zuid-Afrika',
		'South Korea': 'Zuid-Korea',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'Saint Lucia',
		Taiwan: 'Taiwan',
		Tanzania: 'Tanzania',
		Thailand: 'Thailand',
		'Trinidad & Tobago': 'Trinidad en Tobago',
		Tunisia: 'Tunesië',
		Turkey: 'Turkije',
		'United Arab Emirates': 'Verenigde Arabische Emiraten',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Oezbekistan',
		Vietnam: 'Vietnam',
		'United States': 'Verenigde Staten',
		Brazil: 'Brazilië',
	},
	de: {
		France: 'Frankreich',
		Austria: 'Österreich',
		Belgium: 'Belgien',
		Bulgaria: 'Bulgarien',
		Croatia: 'Kroatien',
		Cyprus: 'Zypern',
		'Czech Republic': 'Tschechien',
		Denmark: 'Dänemark',
		Estonia: 'Estland',
		Finland: 'Finnland',
		Germany: 'Deutschland',
		Gibraltar: 'Gibraltar',
		Greece: 'Griechenland',
		Hungary: 'Ungarn',
		Ireland: 'Irland',
		Italy: 'Italien',
		Latvia: 'Lettland',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Litauen',
		Luxembourg: 'Luxemburg',
		Malta: 'Malta',
		Netherlands: 'Niederlande',
		Norway: 'Norwegen',
		Poland: 'Polen',
		Portugal: 'Portugal',
		Romania: 'Rumänien',
		Slovakia: 'Slowakei',
		Spain: 'Spanien',
		Sweden: 'Schweden',
		Switzerland: 'Schweiz',
		'United Kingdom': 'Vereinigtes Königreich',
		'Dominican Republic': 'Dominikanische Republik',
		Albania: 'Albanien',
		Algeria: 'Algerien',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua und Barbuda',
		Argentina: 'Argentinien',
		Armenia: 'Armenien',
		Australia: 'Australien',
		Azerbaijan: 'Aserbaidschan',
		Bahamas: 'Bahamas',
		Bahrain: 'Bahrain',
		Bangladesh: 'Bangladesch',
		Benin: 'Benin',
		Bhutan: 'Bhutan',
		Bolivia: 'Bolivien',
		'Bosnia & Herzegovina': 'Bosnien und Herzegowina',
		Botswana: 'Botswana',
		Brunei: 'Brunei',
		Cambodia: 'Kambodscha',
		Canada: 'Kanada',
		Chile: 'Chile',
		Colombia: 'Kolumbien',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': 'Elfenbeinküste',
		Ecuador: 'Ecuador',
		Egypt: 'Ägypten',
		'El Salvador': 'El Salvador',
		Ethiopia: 'Äthiopien',
		Gabon: 'Gabun',
		Gambia: 'Gambia',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hongkong',
		Indonesia: 'Indonesien',
		Israel: 'Israel',
		Jamaica: 'Jamaika',
		Japan: 'Japan',
		Jordan: 'Jordanien',
		Kazakhstan: 'Kasachstan',
		Kenya: 'Kenia',
		Kuwait: 'Kuwait',
		Laos: 'Laos',
		'Macao SAR China': 'Macao',
		Madagascar: 'Madagaskar',
		Malaysia: 'Malaysia',
		Mauritius: 'Mauritius',
		Mexico: 'Mexiko',
		Moldova: 'Moldawien',
		Monaco: 'Monaco',
		Mongolia: 'Mongolei',
		Morocco: 'Marokko',
		Mozambique: 'Mosambik',
		Namibia: 'Namibia',
		'New Zealand': 'Neuseeland',
		Niger: 'Niger',
		Nigeria: 'Nigeria',
		'North Macedonia': 'Nordmazedonien',
		Oman: 'Oman',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paraguay',
		Peru: 'Peru',
		Philippines: 'Philippinen',
		Qatar: 'Katar',
		Rwanda: 'Ruanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Saudi-Arabien',
		Senegal: 'Senegal',
		Serbia: 'Serbien',
		Singapore: 'Singapur',
		Slovenia: 'Slowenien',
		'South Africa': 'Südafrika',
		'South Korea': 'Südkorea',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'St. Lucia',
		Taiwan: 'Taiwan',
		Tanzania: 'Tansania',
		Thailand: 'Thailand',
		'Trinidad & Tobago': 'Trinidad und Tobago',
		Tunisia: 'Tunesien',
		Turkey: 'Türkei',
		'United Arab Emirates': 'Vereinigte Arabische Emirate',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Usbekistan',
		Vietnam: 'Vietnam',
		'United States': 'Vereinigte Staaten',
		Brazil: 'Brasilien',
	},
	es: {
		France: 'Francia',
		Austria: 'Austria',
		Belgium: 'Bélgica',
		Bulgaria: 'Bulgaria',
		Croatia: 'Croacia',
		Cyprus: 'Chipre',
		'Czech Republic': 'República Checa',
		Denmark: 'Dinamarca',
		Estonia: 'Estonia',
		Finland: 'Finlandia',
		Germany: 'Alemania',
		Gibraltar: 'Gibraltar',
		Greece: 'Grecia',
		Hungary: 'Hungría',
		Ireland: 'Irlanda',
		Italy: 'Italia',
		Latvia: 'Letonia',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Lituania',
		Luxembourg: 'Luxemburgo',
		Malta: 'Malta',
		Netherlands: 'Países Bajos',
		Norway: 'Noruega',
		Poland: 'Polonia',
		Portugal: 'Portugal',
		Romania: 'Rumanía',
		Slovakia: 'Eslovaquia',
		Spain: 'España',
		Sweden: 'Suecia',
		Switzerland: 'Suiza',
		'United Kingdom': 'Reino Unido',
		'Dominican Republic': 'República Dominicana',
		Albania: 'Albania',
		Algeria: 'Argelia',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua y Barbuda',
		Argentina: 'Argentina',
		Armenia: 'Armenia',
		Australia: 'Australia',
		Azerbaijan: 'Azerbaiyán',
		Bahamas: 'Bahamas',
		Bahrain: 'Baréin',
		Bangladesh: 'Bangladés',
		Benin: 'Benín',
		Bhutan: 'Bután',
		Bolivia: 'Bolivia',
		'Bosnia & Herzegovina': 'Bosnia y Herzegovina',
		Botswana: 'Botsuana',
		Brunei: 'Brunéi',
		Cambodia: 'Camboya',
		Canada: 'Canadá',
		Chile: 'Chile',
		Colombia: 'Colombia',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': 'Costa de Marfil',
		Ecuador: 'Ecuador',
		Egypt: 'Egipto',
		'El Salvador': 'El Salvador',
		Ethiopia: 'Etiopía',
		Gabon: 'Gabón',
		Gambia: 'Gambia',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hong Kong',
		Indonesia: 'Indonesia',
		Israel: 'Israel',
		Jamaica: 'Jamaica',
		Japan: 'Japón',
		Jordan: 'Jordania',
		Kazakhstan: 'Kazajistán',
		Kenya: 'Kenia',
		Kuwait: 'Kuwait',
		Laos: 'Laos',
		'Macao SAR China': 'Macao',
		Madagascar: 'Madagascar',
		Malaysia: 'Malasia',
		Mauritius: 'Mauricio',
		Mexico: 'México',
		Moldova: 'Moldavia',
		Monaco: 'Mónaco',
		Mongolia: 'Mongolia',
		Morocco: 'Marruecos',
		Mozambique: 'Mozambique',
		Namibia: 'Namibia',
		'New Zealand': 'Nueva Zelanda',
		Niger: 'Níger',
		Nigeria: 'Nigeria',
		'North Macedonia': 'Macedonia del Norte',
		Oman: 'Omán',
		Pakistan: 'Pakistán',
		Panama: 'Panamá',
		Paraguay: 'Paraguay',
		Peru: 'Perú',
		Philippines: 'Filipinas',
		Qatar: 'Catar',
		Rwanda: 'Ruanda',
		'San Marino': 'San Marino',
		'Saudi Arabia': 'Arabia Saudita',
		Senegal: 'Senegal',
		Serbia: 'Serbia',
		Singapore: 'Singapur',
		Slovenia: 'Eslovenia',
		'South Africa': 'Sudáfrica',
		'South Korea': 'Corea del Sur',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'Santa Lucía',
		Taiwan: 'Taiwán',
		Tanzania: 'Tanzania',
		Thailand: 'Tailandia',
		'Trinidad & Tobago': 'Trinidad y Tobago',
		Tunisia: 'Túnez',
		Turkey: 'Turquía',
		'United Arab Emirates': 'Emiratos Árabes Unidos',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Uzbekistán',
		Vietnam: 'Vietnam',
		'United States': 'Estados Unidos',
		Brazil: 'Brasil',
	},
	fr: {
		France: 'France',
		Austria: 'Autriche',
		Belgium: 'Belgique',
		Bulgaria: 'Bulgarie',
		Croatia: 'Croatie',
		Cyprus: 'Chypre',
		'Czech Republic': 'République tchèque',
		Denmark: 'Danemark',
		Estonia: 'Estonie',
		Finland: 'Finlande',
		Germany: 'Allemagne',
		Gibraltar: 'Gibraltar',
		Greece: 'Grèce',
		Hungary: 'Hongrie',
		Ireland: 'Irlande',
		Italy: 'Italie',
		Latvia: 'Lettonie',
		Liechtenstein: 'Liechtenstein',
		Lithuania: 'Lituanie',
		Luxembourg: 'Luxembourg',
		Malta: 'Malte',
		Netherlands: 'Pays-Bas',
		Norway: 'Norvège',
		Poland: 'Pologne',
		Portugal: 'Portugal',
		Romania: 'Roumanie',
		Slovakia: 'Slovaquie',
		Spain: 'Espagne',
		Sweden: 'Suède',
		Switzerland: 'Suisse',
		'United Kingdom': 'Royaume-Uni',
		'Dominican Republic': 'République dominicaine',
		Albania: 'Albanie',
		Algeria: 'Algérie',
		Angola: 'Angola',
		'Antigua & Barbuda': 'Antigua-et-Barbuda',
		Argentina: 'Argentine',
		Armenia: 'Arménie',
		Australia: 'Australie',
		Azerbaijan: 'Azerbaïdjan',
		Bahamas: 'Bahamas',
		Bahrain: 'Bahreïn',
		Bangladesh: 'Bangladesh',
		Benin: 'Bénin',
		Bhutan: 'Bhoutan',
		Bolivia: 'Bolivie',
		'Bosnia & Herzegovina': 'Bosnie-Herzégovine',
		Botswana: 'Botswana',
		Brunei: 'Brunei',
		Cambodia: 'Cambodge',
		Canada: 'Canada',
		Chile: 'Chili',
		Colombia: 'Colombie',
		'Costa Rica': 'Costa Rica',
		'Côte d’Ivoire': "Côte d'Ivoire",
		Ecuador: 'Équateur',
		Egypt: 'Égypte',
		'El Salvador': 'Salvador',
		Ethiopia: 'Éthiopie',
		Gabon: 'Gabon',
		Gambia: 'Gambie',
		Ghana: 'Ghana',
		Guatemala: 'Guatemala',
		Guyana: 'Guyana',
		'Hong Kong': 'Hong Kong',
		Indonesia: 'Indonésie',
		Israel: 'Israël',
		Jamaica: 'Jamaïque',
		Japan: 'Japon',
		Jordan: 'Jordanie',
		Kazakhstan: 'Kazakhstan',
		Kenya: 'Kenya',
		Kuwait: 'Koweït',
		Laos: 'Laos',
		'Macao SAR China': 'Macao',
		Madagascar: 'Madagascar',
		Malaysia: 'Malaisie',
		Mauritius: 'Maurice',
		Mexico: 'Mexique',
		Moldova: 'Moldavie',
		Monaco: 'Monaco',
		Mongolia: 'Mongolie',
		Morocco: 'Maroc',
		Mozambique: 'Mozambique',
		Namibia: 'Namibie',
		'New Zealand': 'Nouvelle-Zélande',
		Niger: 'Niger',
		Nigeria: 'Nigéria',
		'North Macedonia': 'Macédoine du Nord',
		Oman: 'Oman',
		Pakistan: 'Pakistan',
		Panama: 'Panama',
		Paraguay: 'Paraguay',
		Peru: 'Pérou',
		Philippines: 'Philippines',
		Qatar: 'Qatar',
		Rwanda: 'Rwanda',
		'San Marino': 'Saint-Marin',
		'Saudi Arabia': 'Arabie saoudite',
		Senegal: 'Sénégal',
		Serbia: 'Serbie',
		Singapore: 'Singapour',
		Slovenia: 'Slovénie',
		'South Africa': 'Afrique du Sud',
		'South Korea': 'Corée du Sud',
		'Sri Lanka': 'Sri Lanka',
		'St. Lucia': 'Sainte-Lucie',
		Taiwan: 'Taïwan',
		Tanzania: 'Tanzanie',
		Thailand: 'Thaïlande',
		'Trinidad & Tobago': 'Trinité-et-Tobago',
		Tunisia: 'Tunisie',
		Turkey: 'Turquie',
		'United Arab Emirates': 'Émirats arabes unis',
		Uruguay: 'Uruguay',
		Uzbekistan: 'Ouzbékistan',
		Vietnam: 'Vietnam',
		'United States': 'États-Unis',
		Brazil: 'Brésil',
	},
};
